export function isMacOS() {
  return window.navigator.userAgent.indexOf('Mac') !== -1;
}
